import { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import FacebookLogin from '@greatsumini/react-facebook-login';
import { useNavigate } from "react-router-dom";

const FacebookAuthButton = ({ onSuccess }) => (
  <FacebookLogin
	className="bg-brandteal text-brandwhite hover:bg-brandorange px-3 py-3 rounded-sm"
	appId={process.env.REACT_APP_FACEBOOK_ID}
	autoLoad={true}
	fields="name,email,picture"
    scope="email, pages_show_list, instagram_basic, instagram_manage_messages, pages_read_engagement, pages_manage_metadata, public_profile, instagram_manage_insights"
	onSuccess={onSuccess}
	icon="fa-facebook"
	>Authenticate with Facebook</FacebookLogin>
);

const ReAuth = ({ openAuth, setOpenAuth }) => {
  let navigate = useNavigate();

  // Log user in to fb set fb access token
  const logUserIntoFB = (response) => {
    sessionStorage.setItem("fbSession", response.accessToken);
    navigate("/app/set-entity");
  };

  return (
    <Transition.Root show={openAuth} as={Fragment}>
      <Dialog
        as="div"
        className="fixed z-10 inset-0"
        onClose={() => setOpenAuth(false)}
      >
        <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <Dialog.Overlay className="fixed inset-0 bg-gray-500 bg-opacity-25 transition-opacity" />
          </Transition.Child>

          <span
            className="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <div className="relative inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-sm sm:w-full sm:p-6">
              <div>
                <div className="mt-3 text-center sm:mt-5">
                  <Dialog.Title
                    as="h3"
                    className="text-lg leading-6 font-medium text-gray-900"
                  >
                    Re-Authorize with Facebook
                  </Dialog.Title>
                  <div className="mt-2">
                    <div className="mt-8">
                      <FacebookAuthButton onSuccess={logUserIntoFB} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="mt-2 sm:mt-2">
                <button
                  type="button"
                  className="inline-flex justify-center w-full shadow-sm px-4 py-2 text-xl uppercase font-bold text-brandteal hover:text-brandblack focus:outline-none sm:text-sm"
                  onClick={() => setOpenAuth(false)}
                >
                  No, Cancel
				  </button>
              </div>
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default ReAuth;